<template>
  <div class="stage">
    <div class="stage-header">
      <div class="stage-status">
        <div class="stage-status__label">
          {{ $t('Исполнение нормы') }}
        </div>
        <div class="stage-status__value">
          {{ $t('Требуется ввести данные о статусе исполнения нормы') }}
        </div>
      </div>
      <div
        class="stage-add"
        @click="changeShowModal"
        @keyup.enter="changeShowModal"
        @keyup.space="changeShowModal"
        role="button"
        tabindex="0"
        :aria-label="$t('Добавить стадию')"
      >
        +
      </div>
      <LawNormViewStageModal
        v-if="showModal"
        :stages="norm.stages"
        :kind-by-laws="norm.kindByLaw"
        :stage="stage"
        @save="save"
        @cancel="cancel"
      />
    </div>
  </div>
</template>
<script>
  import LawNormViewStageModal from '@/components/law/LawNormViewStageModal.vue'
  import { mapMutations } from 'vuex'
  import LAW from '@/model/law'

  export default {
    name: "LawNormViewStage",
    components: {
      LawNormViewStageModal
    },

    props: {
      norm: {
        type: Object,
        required: true
      },
      stage: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        showModal: false
      }
    },

    watch: {
      stage: function(newVal) {
        if (newVal) {
          this.showModal = true
        }
      }
    },

    methods: {
      ...mapMutations(['setLoading']),

      changeShowModal () {
        this.showModal = !this.showModal
      },

      save (form) {
        this.$emit('save', form)
        this.changeShowModal()
        this.clearStage()
      },

      cancel () {
        this.changeShowModal()
        this.clearStage()
      },

      clearStage() {
        this.$emit('clear:stage')
      }
    }
  }
</script>
<style lang="scss">
  .stage {
    &-status {
      display: flex;
      padding: 35px 0;

      &__label {
        width: 300px;
        font-weight: 600;
        color: #646363;
      }

      &__value {
        font-weight: 600;
      }
    }

    &-add {
      width: 38px;
      height: 38px;
      border-radius: 50px;
      border: 1px solid #575555;
      font-weight: 600;
      font-size: 30px;
      line-height: 32px;
      color: #575555;
      text-align: center;
      cursor: pointer;
    }
  }
</style>
